import React, { useState } from 'react';

import { Box, Popover } from '@mui/material';

import FilePreviewModal from '../../Modals/FilePreviewModal';
import { isAttachmentAvailable } from '../../Utilities/attachmentScan';
import AttachmentScanStatus from '../../Utilities/AttachmentScanStatus';
import DocTypeIcon from '../../Utilities/DocTypeIcon';
import { classes } from '../styles';

import type { IJobAttachment } from '../../Modals/FilePreviewModal';
import type { MalwareScanFields } from '../../Utilities/attachmentScan';

export interface Attachment extends MalwareScanFields {
  id: number;
  attached_file_name: string;
  attached_content_type: string;
  url: string;
  created_at: string;
  previewable: boolean;
}

const AttachmentsList = ({
  attachments,
  isOpen,
  handleClose,
  anchorEl
}: {
  attachments: Attachment[];
  isOpen: boolean;
  handleClose: () => void;
  anchorEl: Element | null;
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState<IJobAttachment | null>(null);

  const sortedAttachments = [...attachments].reverse();

  return (
    <Box>
      {selectedAttachment ? (
        <FilePreviewModal
          applicationLink={selectedAttachment?.application_link}
          isShareable={false}
          previewOpen={previewOpen}
          selectedAttachment={selectedAttachment}
          setPreviewOpen={setPreviewOpen}
        />
      ) : null}
      <Popover
        anchorEl={anchorEl}
        id={isOpen ? 'applicant-attachments' : undefined}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Box>
          {sortedAttachments?.length < 1 && (
            <Box sx={{ padding: '7px', ...classes.fileName }}>No attachments</Box>
          )}
          {sortedAttachments?.map((attachment) => {
            const attachmentAvailable = isAttachmentAvailable(attachment);

            return (
              <Box
                key={attachment.id}
                id="specific-attachment-option"
                onClick={
                  attachmentAvailable
                    ? () => {
                        setSelectedAttachment(attachment);
                        setPreviewOpen(true);
                      }
                    : undefined
                }
                sx={{
                  ...classes.attachmentItem,
                  cursor: attachmentAvailable ? 'pointer' : 'default'
                }}
              >
                <Box sx={classes.fileIcon}>
                  {DocTypeIcon(attachment.attached_file_name.split('.').pop())}
                </Box>
                <Box>
                  <Box sx={classes.fileName}>{attachment.attached_file_name}</Box>
                  <AttachmentScanStatus showUnavailableReason attachment={attachment} />
                </Box>
              </Box>
            );
          })}
        </Box>
      </Popover>
    </Box>
  );
};

export default AttachmentsList;
